import { RequestStatus } from '@upright/ui/api/common/types';
import { toSimplifiedSource } from '@upright/ui/common/upright/core/impact-lenses/insights/source-description/source-description';
import { clientDatumSourceTooltipText } from '@upright/ui/common/upright/core/impact-lenses/insights/source-description/source-description-tooltip';
import { useTargetsLensContext } from '@upright/ui/common/upright/core/impact-lenses/targets/common/use-targets-lens-context';
import Skeleton from 'react-loading-skeleton';

export function TargetsSourceTooltipContent() {
  const ctx = useTargetsLensContext();
  if (!ctx) {
    return <></>;
  }
  const data = ctx.data;
  if (data.loadingStatus === RequestStatus.LOADING) {
    return <Skeleton width="5.0em" />;
  }
  const items = data.targets;
  if (!items) {
    return <>Error</>;
  }
  return <>{clientDatumSourceTooltipText(toSimplifiedSource(items))}</>;
}
